import { render } from "./BannerBlock.vue?vue&type=template&id=2fbdcabc"
import script from "./BannerBlock.vue?vue&type=script&lang=js"
export * from "./BannerBlock.vue?vue&type=script&lang=js"

import "./BannerBlock.vue?vue&type=style&index=0&id=2fbdcabc&lang=scss"

import exportComponent from "/codebuild/output/src719114813/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__